import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import { ContentSensitivityInfo } from 'src/components/ContentSensitivityInfo';
import { getContentSensitivityInfo } from 'src/components/ContentSensitivityInfo/utils';
import { Loader } from './components/Loader';
import { InsightBox } from '../InsightBox';
import { useStyles } from './useStyles';

export const ChannelPolicy = ({
  classes,
  assetType,
  sensitivity,
  loading,
  horizontalLayout,
  policyTitle,
}) => {
  const styles = useStyles({ classes });

  const { title, reasonTitle, reasonDesc, labelDesc } = getContentSensitivityInfo(
    policyTitle,
    sensitivity,
    assetType
  );

  const subtitle = useMemo(
    () =>
      !loading && (
        <>
          {reasonTitle}
          {reasonDesc}
        </>
      ),
    [loading, reasonDesc, reasonTitle]
  );

  return (
    <div className={styles.root}>
      <Typography className={styles.boxGroupTitle}>Policy</Typography>

      <InsightBox
        className={styles.content}
        classes={{ collapseWrapperInner: styles.collapseWrapperInner }}
        title={title}
        subtitle={subtitle}
        topRightSlot={
          !loading && (
            <Typography
              className={styles.badge}
              data-sensitivity={labelDesc}
            >
              {labelDesc}
            </Typography>
          )
        }
        collapsableContent={
          !loading &&
          sensitivity?.reasonDetails && (
            <ContentSensitivityInfo
              classes={{
                header: styles.hide,
                reasonTitle: styles.hide,
                reason: styles.reason,
              }}
              assetType={assetType}
              sensitivity={sensitivity}
              horizontalLayout={horizontalLayout}
              policyTitle={policyTitle}
            />
          )
        }
      >
        {loading && <Loader />}
      </InsightBox>
    </div>
  );
};

ChannelPolicy.propTypes = {
  classes: PropTypes.shape({}),
  assetType: PropTypes.string,
  sensitivity: PropTypes.shape({
    label: PropTypes.string,
    reason: PropTypes.string,
    reasonDetails: PropTypes.string,
  }),
  loading: PropTypes.bool,
  horizontalLayout: PropTypes.bool,
  policyTitle: PropTypes.bool,
};

ChannelPolicy.defaultProps = {
  classes: null,
  assetType: null,
  sensitivity: null,
  loading: false,
  horizontalLayout: false,
  policyTitle: false,
};
